__turbopack_context__.v({
  "bodySection": "AccommodationCard-module__uNO5Eq__bodySection",
  "changeFieldsBox": "AccommodationCard-module__uNO5Eq__changeFieldsBox",
  "checkInOut": "AccommodationCard-module__uNO5Eq__checkInOut",
  "checkInSection": "AccommodationCard-module__uNO5Eq__checkInSection",
  "checkRow": "AccommodationCard-module__uNO5Eq__checkRow",
  "checkRowIcon": "AccommodationCard-module__uNO5Eq__checkRowIcon",
  "checkRowIconWrap": "AccommodationCard-module__uNO5Eq__checkRowIconWrap",
  "checkRowText": "AccommodationCard-module__uNO5Eq__checkRowText",
  "expandedStay": "AccommodationCard-module__uNO5Eq__expandedStay",
  "externalLink": "AccommodationCard-module__uNO5Eq__externalLink",
  "foldExpandable": "AccommodationCard-module__uNO5Eq__foldExpandable",
  "foldExpandableInner": "AccommodationCard-module__uNO5Eq__foldExpandableInner",
  "foldExpandableOpen": "AccommodationCard-module__uNO5Eq__foldExpandableOpen",
  "foldGroup": "AccommodationCard-module__uNO5Eq__foldGroup",
  "includeIcon": "AccommodationCard-module__uNO5Eq__includeIcon",
  "includeItem": "AccommodationCard-module__uNO5Eq__includeItem",
  "includesItems": "AccommodationCard-module__uNO5Eq__includesItems",
  "includesItemsExpandable": "AccommodationCard-module__uNO5Eq__includesItemsExpandable",
  "includesItemsExpandableInner": "AccommodationCard-module__uNO5Eq__includesItemsExpandableInner",
  "includesItemsExpandableOpen": "AccommodationCard-module__uNO5Eq__includesItemsExpandableOpen",
  "includesSection": "AccommodationCard-module__uNO5Eq__includesSection",
  "includesTitle": "AccommodationCard-module__uNO5Eq__includesTitle",
  "instructionalGroup": "AccommodationCard-module__uNO5Eq__instructionalGroup",
  "metaBlock": "AccommodationCard-module__uNO5Eq__metaBlock",
  "metaIcon": "AccommodationCard-module__uNO5Eq__metaIcon",
  "metaRow": "AccommodationCard-module__uNO5Eq__metaRow",
  "metaText": "AccommodationCard-module__uNO5Eq__metaText",
  "overviewBlock": "AccommodationCard-module__uNO5Eq__overviewBlock",
  "textLinkButton": "AccommodationCard-module__uNO5Eq__textLinkButton",
  "textLinkButtonIcon": "AccommodationCard-module__uNO5Eq__textLinkButtonIcon",
  "textLinkButtonIconExpanded": "AccommodationCard-module__uNO5Eq__textLinkButtonIconExpanded",
});
